import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  IconTick,
} from "@touchtech/web-baselayer-ui";

import css from "./FailedCheckoutModal.module.css";
import useManageFailedCheckoutModal from "./hooks/useManageFailedCheckoutModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const FailedCheckoutModal = ({ isOpen, onClose }: Props) => {
  const { t } = useManageFailedCheckoutModal();

  return (
    <ConfirmationModal isOpen={isOpen} onClose={onClose}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Something went wrong")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {t("Please try again or choose another payment method.")}
        </span>
        <Button
          className={css.okButton}
          width="full"
          sizing="lg"
          onClick={onClose}
        >
          <IconTick />
          {t("OK")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default FailedCheckoutModal;
